import React from "react";
import './Tablero.scss'



const ModalTransferirGuardia =({children})=>
{
    return(
        <div className="ModalTransferirGuardia">
            {children}
        </div>
    )
}
export default ModalTransferirGuardia